import { render, staticRenderFns } from "./BaseBottomNavigatorBar.vue?vue&type=template&id=2f0b48d9&"
import script from "./BaseBottomNavigatorBar.vue?vue&type=script&lang=ts&"
export * from "./BaseBottomNavigatorBar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports